import MenuButtonHomePage from '../MenuButtonHomePage/menu-button-home-page';
import { OPTION_MENU } from '../../../../constants/menu';
import { Navbar } from '../../../../components';

// eslint-disable-next-line react/prop-types
export default function NavBarHomePage({ onSelectMenu }) {
  const navbarItems = [
    {
      id: 'about_us',
      name: 'About Us',
      active: true,
      // onClick: () => {
      //   onSelectMenu(OPTION_MENU.ABOUT_US);
      // },
      onClick: () => window.open('https://fayven.com/about/', '_blank'),
    },
    {
      id: 'faqs',
      name: 'FAQs',
      active: true,
      onClick: () => window.open('https://fayven.com/faq/', '_blank'),
    },
  ];

  return (
    <Navbar
      elements={navbarItems}
      menuItem={<MenuButtonHomePage onClick={onSelectMenu} />}
      action={onSelectMenu}
    />
  );
}
